module.exports = __webpack_public_path__ + "h5/img/one.d072f1cd.png";